export default () => ({
  scantools: [],
  reportTemplates: [],
  apps: [{
    id: 0,
    name: 'All'
  }, {
    id: 1,
    name: 'UK/Europe'
  }, {
    id: 2,
    name: 'Glass US/Canada'
  }, {
    id: 4,
    name: 'Calibration US/Canada'
  }, {
    id: 5,
    name: 'ProTech'
  }],
  areas: [{
    id: 0,
    name: 'Service Details'
  }, {
    id: 1,
    name: 'Recommendations'
  }, {
    id: 2,
    name: 'Scan Readings'
  }, {
    id: 3,
    name: 'Snapshot Data'
  }],
  techInfo: JSON.parse(localStorage.getItem('techInfo'))
})



// WEBPACK FOOTER //
// ./src/store/modules/report/state.js